var SwiperProducts = {
    init:function(){
        console.log("SWIPER PRODUCT INI");

        var swiper = new Swiper(".slider-products .swiper-container", {
            slidesPerView:"auto",
            spaceBetween:30,
            slideToClickedSlide: false,
            freeMode: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }
}
console.log("JE SUIS CHARGE");
$(window).load(function(){
    console.log("TOUT VA BIEN");
    if($(".slider-products").length){
        SwiperProducts.init();
    }
})